import React from "react";
import styles from "./AiFeatures.module.scss";
import Image from "next/image";
function AiFeatures() {
  return (
    <section className={styles.aiFeatures}>
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <h2>AI Shopping Assistant Features</h2>
          <p>
            Experience the power of conversational commerce with our advanced AI
            capabilities.
          </p>
        </div>
        <div className={styles.featuresList}>
          <div className={styles.aiFeatureCard}>
            <div className={styles.featureHeader}>
              <div className={`${styles.featureIcon} ${styles.purple}`}>
                {/* <MessageSquare size={18} /> */}
                <Image
                  src="/agent-icons/message.svg"
                  alt="AI Agents"
                  width={18}
                  height={18}
                  className={styles.whiteIcon}
                />
              </div>
              <h3>Conversational Commerce</h3>
            </div>
            <p>
              Natural language processing enables customers to shop through
              intuitive conversations.
            </p>
            <div className={styles.featureExample}>
              &quot;Hi there! I&quot;m looking for a blue dress for a
              wedding.&quot;
            </div>
          </div>

          <div className={styles.aiFeatureCard}>
            <div className={styles.featureHeader}>
              <div className={`${styles.featureIcon} ${styles.blue}`}>
                {/* <Star size={18} /> */}
                <Image
                  src="/agent-icons/star.svg"
                  alt="AI Agents"
                  width={18}
                  height={18}
                  className={styles.whiteIcon}
                />
              </div>
              <h3>Personalized Recommendations</h3>
            </div>
            <p>
              Advanced algorithms analyze behavior patterns to suggest perfect
              product matches.
            </p>
            <div className={styles.featureExample}>
            &quot;Based on your history, I think you also might like...&quot;
            </div>
          </div>

          <div className={styles.aiFeatureCard}>
            <div className={styles.featureHeader}>
              <div className={`${styles.featureIcon} ${styles.indigo}`}>
                {/* <BarChart3 size={18} /> */}
                <Image
                  src="/agent-icons/bar.svg"
                  alt="AI Agents"
                  width={18}
                  height={18}
                  className={styles.whiteIcon}
                />
              </div>
              <h3>Predictive Analytics</h3>
            </div>
            <p>
              Anticipate customer needs and inventory requirements with
              AI-driven insights.
            </p>
            <div className={styles.featureExample}>
              &quot;Predict: You might need this item next week!&quot;
            </div>
          </div>

          <div className={styles.aiFeatureCard}>
            <div className={styles.featureHeader}>
              <div className={`${styles.featureIcon} ${styles.violet}`}>
                {/* <Globe size={18} /> */}
                <Image
                  src="/agent-icons/globe.svg"
                  alt="Omnichannel Integration"
                  width={18}
                  height={18}
                  className={styles.whiteIcon}
                />
              </div>
              <h3>Omnichannel Integration</h3>
            </div>
            <p>
              Seamless experience across web, mobile, social media, and physical
              stores.
            </p>
            <div className={styles.featureExample}>
              &quot;Continue shopping from any device, anywhere.&quot;
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AiFeatures;
